var map = {
	"./amplify.svg": 70276,
	"./arrow-right.svg": 61240,
	"./btn-arrow.svg": 47056,
	"./check.svg": 94072,
	"./chevron.svg": 56492,
	"./close.svg": 33700,
	"./clutch.svg": 57892,
	"./digital-wire-group.svg": 80668,
	"./facebook.svg": 90196,
	"./github.svg": 22404,
	"./instagram.svg": 14672,
	"./job-admin.svg": 68873,
	"./job-dev.svg": 41216,
	"./job-marketing.svg": 40424,
	"./job-people-care.svg": 53252,
	"./job-product-owner.svg": 53604,
	"./job-ux.svg": 12572,
	"./linkedin.svg": 67656,
	"./machine-learning.svg": 19520,
	"./mobile-development.svg": 76012,
	"./pin-marker.svg": 22274,
	"./product-management.svg": 45760,
	"./quote.svg": 74240,
	"./twitter.svg": 41208,
	"./uruit.svg": 15628,
	"./uruit_black.svg": 99036,
	"./uruit_black_by_NS.svg": 59960,
	"./uruit_by_NS.svg": 16748,
	"./ux-ui.svg": 32456,
	"./web-development.svg": 30700,
	"./youtube.svg": 7359
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38196;